import { render, staticRenderFns } from "./HistoryPopup.vue?vue&type=template&id=fe06e1ae&scoped=true&"
import script from "./HistoryPopup.vue?vue&type=script&lang=js&"
export * from "./HistoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPopup.vue?vue&type=style&index=0&id=fe06e1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe06e1ae",
  null
  
)

export default component.exports